import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomLabelTag = createSvgIcon(
  <path d="m10.056 17.585-3.034 1.287q-.722.304-1.372-.116T5 17.567V8.29q0-.59.424-1.01.425-.42 1.02-.42h7.223q.596 0 1.02.42t.424 1.01v9.278q0 .768-.65 1.188t-1.372.116zm0-1.573 3.61 1.538V8.29H6.445v9.26zm6.5 1.573V5.43h-9.39V4h9.39q.596 0 1.02.42T18 5.43v12.155z" />,
  'CustomLabelTag',
);

export default CustomLabelTag;
